var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex",class:_vm.cssClassWrapper,on:{"click":_vm.onClick}},[_c('i',{staticClass:"mdi",class:_vm.cssClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }